<template lang="pug">
 
  v-dialog(v-model='loadmassive' max-width='500px')
      template(v-slot:activator='{ on }')
        v-btn.mb-2(color='primary' dark v-on='on') Cargar 
      v-card
        v-card-title
          span.headline Carga masiva de datos
        v-card-text
          v-container(grid-list-md) 
            .custom-file.mb-4
              input#customFileLang.custom-file-input(type='file' lang='es' accept=".csv" @change="readFile")
              label.custom-file-label(for='customFileLang') Seleccionar Archivo 
            
            v-data-table.elevation-1( :headers="headers" :items="review")
              template( v-slot:items="props" )
                td {{ props.item.code }}
                td {{ props.item.description }} 
                td {{ props.item.display }}
                td {{ props.item.productType }}
            v-btn( color='primary' type="input"  data-dismiss="modal" @click="saveCVS()")
              v-icon fa-save 
              span.ml-1 Guardar

     

</template>
<style lang="sass">
</style>
<script>
import {productsCollection} from '@/FirebaseConfig'
import moment from 'moment' 
import $ from 'jquery'
import bootstrap from 'bootstrap'
export default {
  data:()=>({
     review:[],
     inputCSV: null,
     loadmassive:false,
     headers: [
      {
        text: 'Código',
        value: 'code',
      },
      {
        text: 'Descripción',
        value: 'description',
      },
      {
        text: 'Presentación',
        value: 'display',
      },
      {
        text: 'Tipo de producto',
        value: 'productType',
      },
     ],

  
  }),
  methods:{
    readFile: function(ev){
      const file = ev.target.files[0]
      const reader = new FileReader()
      reader.onload = e => {
        let data_in =  e.target.result
      
        let lines = data_in.split("\n")
        let result = []
        let headers = [
          'code',
          'description',
          'display',
          'productType',
        ]

        for(var i=0;i<lines.length;i++){
          if(lines[i]!=''){
            let obj = {};
            let currentline=lines[i].split(";")
            for(let j=0; j<headers.length; j++){
              obj[headers[j]] = currentline[j];
              
            }
            result.push(obj);
          }
        }
        this.review = [...result] 
      
      
      }
      reader.readAsText(file)
    },
 
    saveCVS(){
      this.$store.dispatch('Product/massiveAdd', this.review.map(item => ({
        description: item.description,
        display: item.display,
        productType: item.productType,
        code: String(item.code).padStart(0, 4)
      }) ))
    },
  
  },

}
</script>
